import { injectGlobal } from "styled-components"

import { below } from '../style/functions'
import * as vars from "../style/vars"

injectGlobal`
	* {
		box-sizing: border-box;
	}

	img {
    display: block;
    height: auto;
    width: 100%;
	}

  em {
    text-transform: uppercase;
  }

	strong {
    font-weight: bold;
	}

	body {
		overflow-x: hidden;
    font-family: ${vars.fonts.main};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
	}

  h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5 {
    line-height: 1.15
    strong {
      font-style: normal;
      text-transform: uppercase;
      font-weight: normal;
    }
  }


	h1, .h1{
		font-family: ${vars.fonts.header};
		font-weight: normal;
		font-size: 9em;
    font-style: italic;
    line-height: 1;
		${below.mid`
			font-size: 8rem;
		`}
		${below.tablet`
			font-size: 6rem;
		`}	
		${below.mobile`
			font-size: 4rem;
		`}
		${below.xs`
			font-size: 3rem;
		`}	
	}
	h2, .h2 {
		font-family: ${vars.fonts.header};
		font-weight: normal;
    font-style: italic;
		font-size:3.2rem;
		padding-bottom: ${(vars.padding.inner / 2)}rem;
    letter-spacing: 0.03em;
		${below.tablet`
			font-size:2.6rem;
		`}	
		${below.mobile`
			font-size:1.8rem;
		`}	
	}
	h3, .h3{
		font-family: ${vars.fonts.header};
		font-weight: normal;
		font-size:2rem;
    font-style: italic;
		padding-bottom: ${vars.padding.inner}rem;

		${below.tablet`
			font-size:2.8rem;
		`}	
		${below.mobile`
			font-size:1.9rem;
			padding-bottom: ${(vars.padding.inner / 2)}rem;

		`}	
	}
	h4, .h4 {
    color: #C7B584;
		font-weight: bold;
    font-size: inherit;
		padding-bottom: ${(vars.padding.inner * 2)}rem;
    margin: 0
    padding: 0
	}
	h5, .h5 {
		font-family: ${vars.fonts.header};
		font-weight: normal;
		font-size:2rem;
    font-style: italic;
		padding-bottom: ${vars.padding.inner}rem;

		${below.tablet`
			font-size:1.8rem;
		`}	
		${below.mobile`
			font-size:1.5rem;
			padding-bottom: ${(vars.padding.inner / 2)}rem;

		`}	
	}

  hr {
    border: 0 none
    background: ${vars.colors.brandPrimary}
    height: 1px
    max-width: 150px
    margin: 3rem auto

    :first-child {
      margin-top: 0
    }
  }

  input {
    border-radius: 0;
  }

	a {
		color: inherit;
	}

  p + p {
    margin-top: 1em;
  }

	svg{
		fill: currentcolor;
	}
`
